import SearchAndOrder from '@core/interfaces/bpc-search-and-order';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { Invoice } from '@accounting/interfaces/invoice';
import { Payment } from '@accounting/interfaces/payment';
import { DirectDebitFile } from '@accounting/interfaces/direct-debit-file';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import InvoiceDetails from '@accounting/components/details/invoice-details/invoice-details.vue';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import StripePaymentModal from '@accounting/components/payments/stripe/stripe-payment-modal.vue';
import { getProp, setProp } from '@shared/helpers/operators';
import StripeCancelModal from '@accounting/components/payments/stripe/stripe-cancel-modal.vue';
import BancontactPaymentModal from '@accounting/components/payments/bancontact/bancontact-payment-modal.vue';
import { loadStripe } from '@stripe/stripe-js/pure';
import copy from 'copy-to-clipboard';
import AutoFormGroup from '@shared/components/forms/auto-form/auto-form-group/auto-form-group.vue';
import moment from 'moment';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import WipayTerminalPaymentModal from '@accounting/components/payments/wipay-terminal/wipay-terminal-payment-modal/wipay-terminal-payment-modal.vue';
import { Terminal } from '@payment-terminals/interfaces/terminal';
import { PosSession } from '@pos/interfaces/pos-session';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';
import ModulesHelper from '@core/services/modules.helper';
import Select from '@shared/components/forms/inputs/select/select.vue';
import InvoiceValidationModal from '@accounting/components/modals/invoice-validation-modal/invoice-validation-modal.vue';
import TicketToDirectDebitFileModal from '@accounting/components/modals/ticket-to-direct-debit-file-modal/ticket-to-direct-debit-file-modal.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';
import InvoiceMarkAsPaidModal from '@accounting/components/modals/invoice-mark-as-paid-modal/invoice-mark-as-paid-modal.vue';

import InvoiceSyncModal from '@accounting/components/others/invoice-sync-modal/invoice-sync-modal.vue';
import InvoiceSyncMixin from '@accounting/components/others/invoice-sync-modal/invoice-sync-mixin';
import BpcPaymentSyncModal from '@accounting/components/others/payment-sync-modal/payment-sync-modal.vue';
import PaymentSyncMixin from '@accounting/components/others/payment-sync-modal/payment-sync-mixin';

import HtmlToPdf from '@shared/components/html-to-pdf/html-to-pdf.vue';
import InvoiceDetailsPresentational from '@accounting/components/details/invoice-details-presentational/invoice-details-presentational.vue';
import { TicketHelper } from '@accounting/helpers/TicketHelper';
import { appConfig } from '@/config/app-config';

import HtmlToPrinter from '@shared/components/html-to-printer/html-to-printer.vue';
import PrintTicket from '@accounting/components/details/print-ticket/print-ticket.vue';
import InvoiceForm from '@accounting/components/forms/invoice-form/invoice-form.vue';
import DownloadInvoiceInPdfModal from '@accounting/components/modals/download-invoice-in-pdf-modal/download-invoice-in-pdf-modal.vue';
import InvoiceRedraftModal from '@accounting/components/modals/invoice-redraft-modal/invoice-redraft-modal.vue';

@Component({
  name: 'bpc-invoice-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-modal': DrawerModal,
    'bpc-invoice-details': InvoiceDetails,
    'bpc-invoice-details-presentational': InvoiceDetailsPresentational,
    'bpc-stripe-payment-modal': StripePaymentModal,
    'bpc-stripe-cancel-modal': StripeCancelModal,
    'bpc-bancontact-payment-modal': BancontactPaymentModal,
    'bpc-auto-form-group': AutoFormGroup,
    'bpc-wipay-terminal-payment-modal': WipayTerminalPaymentModal,
    'bpc-select': Select,
    'bpc-invoice-validation-modal': InvoiceValidationModal,
    'bpc-ticket-to-direct-debit-file-modal': TicketToDirectDebitFileModal,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
    'bpc-bulk-recover-modal': BulkRecoverModal,
    'bpc-invoice-mark-as-paid-modal': InvoiceMarkAsPaidModal,
    'bpc-download-invoice-pdf-modal': DownloadInvoiceInPdfModal,
    'bpc-invoice-sync-modal': InvoiceSyncModal,
    'bpc-html-to-pdf': HtmlToPdf,
    'bpc-html-to-printer': HtmlToPrinter,
    'bpc-print-ticket': PrintTicket,
    'bpc-invoice-form': InvoiceForm,
    'bc-invoice-redraft-modal': InvoiceRedraftModal,
    BpcPaymentSyncModal,
  },
})
export default class InvoiceTable extends mixins(
  AbstractTable,
  InvoiceSyncMixin,
  SendMessageUsingTemplateMixin,
  PaymentSyncMixin,
) {
  [x: string]: any;
  declare $refs: AbstractTable['$refs'] &
    InvoiceSyncMixin['$refs'] &
    PaymentSyncMixin['$refs'] & {
      // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
      paymentStdForm: InstanceType<typeof StdForm> & {
        formModel: AnyEntity;
        saveEntity(): Promise<BPCGenericApiResponse>;
      };
      bulkSendInvoicesConfirmationModal: InstanceType<typeof ConfirmationModal> & {
        onOpenModal(id): void;
        onCloseModal(): void;
      };
      sendSingleInvoiceConfirmationModal: InstanceType<typeof ConfirmationModal> & {
        onOpenModal(id): void;
        onCloseModal(): void;
      };
      ticketsToInvoiceConfirmationModal: InstanceType<typeof ConfirmationModal> & {
        onOpenModal(id): void;
        onCloseModal(): void;
      };
      stripePaymentModal: InstanceType<typeof StripePaymentModal> & {
        makePayment();
      };
      bancontactPaymentModal: InstanceType<typeof BancontactPaymentModal> & {
        makePayment();
      };
      sentToPosCheckoutConfirmationModal: InstanceType<typeof ConfirmationModal> & {
        onOpenModal(id): void;
        onCloseModal(): void;
      };
      sentToPosCheckoutConfirmationModalV2: InstanceType<typeof ConfirmationModal> & {
        onOpenModal(id): void;
        onCloseModal(): void;
      };
      bulkPdfConfirmationModal: InstanceType<typeof ConfirmationModal> & {
        onOpenModal(id): void;
        onCloseModal(): void;
      };
      htmlToPrinter: InstanceType<typeof HtmlToPrinter> & {
        printContent(): void;
      };
    };

  @Prop(Boolean) showDrawerLarge: boolean;
  @Prop(String) declare readonly title: string;
  @Prop(String) declare readonly subtitle: string;
  @Prop({ type: Boolean, default: false })
  readonly showActionButtonText: boolean;
  @Prop(Array) readonly accountingJournalsType: string[];
  @Prop({ type: Boolean, default: false })
  readonly validateInvoicePageAction: boolean;
  @Prop({ type: Boolean, default: false }) readonly sendInvoiceAction: boolean;
  @Prop({ type: Boolean, default: false })
  readonly syncInvoicePageAction: boolean;
  @Prop({ type: Boolean, default: false })
  readonly syncPaymentPageAction: boolean;
  @Prop({ type: Boolean, default: true })
  readonly bulkMoveToTrashPageAction: boolean;
  @Prop({ type: Boolean, default: false })
  readonly bulkAddToDirectDebitFilePageAction: boolean;
  @Prop({ type: Boolean, default: false })
  readonly markInvoicesAsPaidPageAction: boolean;
  @Prop({ type: Boolean, default: false })
  readonly withComment: boolean;

  @Prop({ type: String, default: 'export' })
  readonly localExportConfigName!: string;

  public entity: Invoice = null;
  public entityName = 'invoice';
  public pluralEntityName = 'invoices';
  public permissionEntityNameToUse = 'invoices';
  public invoiceDetailsModalTitle = '';
  public invoiceCode = '';
  public showStripePaymentModal: boolean = false;
  public showStripeCancelModal: boolean = false;
  public showBancontactPaymentModal: boolean = false;
  public showWipayTerminalPaymentModal: boolean = false;
  public stripeKey: number = 0;
  public payAmount: number = 0;
  public wipayTerminalKey: number = 0;
  public stripePaymentIntentId: string = null;
  public directDebitFilesAvailableforTicket: DirectDebitFile[] = [];

  public showDrawerPaymentSection = false;
  public paymentEntity: Payment = null;

  public terminals: Terminal[] = [];

  public copiedText: string = 'global.payment_link_copied';

  public paymentIdsStr: string = 'loading';

  // Common state for bulk actions
  public searchAndOrder: SearchAndOrder = null;
  // State to manage invoice validation
  public uniqIdForInvoiceForm = null;
  public showInvoiceValidationModal = false;
  public showInvoiceRedraftModal = false;
  public showTicketAddToDirectDebitFileModal = false;
  public bulkInvoiceValidation: boolean = false;
  public msgCanBePartialEdited: string = this.$t('accounting.invoice.can_partial_edit') as string;
  public msgCanNotBeEdited: string = this.$t('accounting.invoice.can_not_edit') as string;

  // State to manage mark as paid invoice.
  public showInvoiceMarkAsPaidModal = false;

  public savePathForInvoiceForm: string = null;
  // Data used for download pdf
  public showBulkPDFModal: boolean = false;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];
  readonly errorMessageText: string = 'global.generic.error_form_action';

  public ticketsToInvoiceFormReady = false;
  public ticketsToInvoiceFormFields = [];
  public ticketsToInvoiceFormModel = {
    invoice_date: null,
    due_date: null,
  };

  ticketToPrint: Invoice = null;
  printingTicket: boolean = false;
  printPreviewTicket: boolean = false;
  orderItemsInTicketToPrint: any[] = [];
  paymentsInTicketToPrint: any[] = [];
  disablePrintingTicket = false;

  prepareTicketsToInvoiceForm() {
    this.$bpcConfig.getEntityConfig('invoice.forms.tickets-into-invoice').subscribe(res => {
      this.ticketsToInvoiceFormFields = Object.values(res.data.fields);
      this.ticketsToInvoiceFormModel.invoice_date = moment().format('YYYY-MM-DD');
      this.ticketsToInvoiceFormModel.due_date = moment()
        .add(1, 'months')
        .format('YYYY-MM-DD');
      this.ticketsToInvoiceFormReady = true;
    });
  }

  get bancontactReturnUrl() {
    return `${location.origin}${this.$route.fullPath}`;
  }

  get availableToPosCheckout() {
    return (
      this.$authorizationService.hasPermissionForAction('pos_sessions', 'pos_checkout', true) &&
      this.entity?.invoice_type === 'ticket' &&
      this.entity?.status === 'to_pay' &&
      this.openPosSessionId &&
      this.$store.getters['centerSettings/usePosV2'] &&
      appConfig.modules.activatePosV2
    );
  }

  getPayments(): Payment[] {
    return this.$refs.stdForm?.formModel?.payments ?? [];
  }

  getPaymentIdsStr() {
    const payments = this.getPayments();
    return payments
      .map(payment => payment.id)
      .sort((a, b) => a - b) // NOTE: we need it to always have the same order
      .join(',');
  }

  onModelLoaded(event) {
    /*NOTE:
      If status is not draft
      invoice cant be full edited
      and Invoice can be partial edited
      the endpoint is changed
     */
    const formModel = this.$refs.stdForm.formModel;
    const canBePartialEdited = formModel.can_be_partial_edited;
    const canBeFullEdited = formModel.can_be_full_edited;
    const id = formModel.id;
    if (formModel.status != 'draft' && !canBeFullEdited && canBePartialEdited) {
      const route = `${this.$bpcApiRouteHelper.getEntityPath(
        this.entityName,
      )}/${id}/partial-update`;
      this.savePathForInvoiceForm = route;
    } else {
      this.savePathForInvoiceForm = null;
    }
    // NOTE: in other case the route is the put entity by default.
  }
  get selectedAccountingJournalId() {
    return this.filterModel?.accounting_journal_id || null;
  }

  onLoadItems() {
    this.$store.dispatch('invoiceCounts/getInvoicesCount');
    this.$store.dispatch('invoiceCounts/getCreditNotesCount');
    setTimeout(() => {
      if (this.$refs.entityTable) {
        this.$refs.entityTable.$on('on-click-display', $event => {
          if (this.displayFieldsToSubscribe.includes($event.field)) {
            this.onEdit($event, true);
          }
        });
      }
    });
  }
  getInvoicesToSyncItemsConfirmationModalConfig() {
    return {
      id: 'modal-invoices-to-sync-items',
      title: this.$t('global.modals.invoices-to-sync-items.title') as string,
      body: this.$t('global.modals.invoices-to-sync-items.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  getTicketsToInvoiceConfirmationModalConfig() {
    return {
      id: 'modal-tickets-to-invoice',
      title: this.$t('global.modals.tickets-to-invoice.title') as string,
      body: this.$t('global.modals.tickets-to-invoice.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  getBulkSendInvoicesConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'modal-send-bulk-invoices',
      title: this.$t('global.modals.send-invoices.title') as string,
      body: this.$t('global.modals.send-invoices.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  getSendSingleInvoiceConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'modal-send-single-invoice',
      title: this.$t('global.modals.send-single-invoice.title') as string,
      body: this.$t('global.modals.send-single-invoice.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  getBulkSoftDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: this.entityName + '-bulk-soft-delete-modal',
      title: this.$t('global.modals.bulk-soft-delete.title', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
        entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
      }),
      body: this.$t('global.modals.bulk-soft-delete-invoices.body', {
        entityName: this.$t('global.models.' + this.entityName + '.name'),
        entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
        thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
        thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
      }) as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }
  getSendToPosCheckoutConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'modal-send-to-pos-checkout',
      title: this.$t('global.modals.send-to-pos-checkout.title') as string,
      body: this.$t('global.modals.send-to-pos-checkout.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }
  getSendToPosCheckoutConfirmationModalConfigV2(): ConfirmationModalConfig {
    return {
      id: 'modal-send-to-pos-checkout-v2',
      title: this.$t('global.actions.pos-checkout') as string,
      body: this.$t('global.modals.send-ticket-to-pos-checkout.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }
  get bulkPdfConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'modal-bulk-generate-pdf',
      title: this.$t('global.modals.bulk_generate_pdf.title') as string,
      body: this.$t('global.modals.bulk_generate_pdf.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  public customPageActions = {
    bulkSendMessageUsingTemplate: {
      activated: false,
      type: 'action',
      icon: 'envelope', //'times',
      variant: 'info',
      text: 'send_message_using_template',
      show: false,
      event: 'bulk-send-message-using-template',
      selectElements: true,
      tag: 'right',
      permissions: ['bulk_message'],
    },
    invoicesToSyncItems: {
      activated: false,
      type: 'action',
      icon: 'cloud-upload-alt',
      variant: 'primary',
      text: 'invoices_to_sync_items',
      show: false,
      event: 'invoices-to-sync-items',
      selectElements: true,
      tag: 'left',
      permissions: ['invoices_to_sync_items'],
    },
    syncPayments: {
      activated: false,
      type: 'action',
      icon: 'cloud-download-alt',
      variant: 'primary',
      text: 'sync_payments',
      show: false,
      event: 'sync-payments',
      selectElements: true,
      tag: 'left',
      permissions: ['invoices_to_sync_items'], // NOTE If you can sync invoices, you can sync payments
    },
    ticketsToDirectDebitFile: {
      activated: false,
      type: 'action',
      icon: 'file-invoice',
      variant: 'primary',
      text: 'tickets_to_direct_debit_file',
      show: false,
      event: 'tickets-to-direct-debit-file',
      selectElements: true,
      tag: 'left',
      permissions: ['tickets_to_direct_debit_file'],
    },
    ticketsToInvoice: {
      activated: false,
      type: 'action',
      icon: 'archive',
      variant: 'primary',
      text: 'tickets_to_invoice',
      show: true,
      event: 'tickets-to-invoice',
      selectElements: true,
      tag: 'left',
      permissions: ['tickets_to_invoice'],
    },
    validateInvoices: {
      activated: false,
      type: 'action',
      icon: 'check-circle',
      variant: 'primary',
      text: 'validate',
      show: true,
      event: 'validate-invoices',
      selectElements: true,
      tag: 'left',
      permissions: ['show'],
    },
    markInvoicesAsPaid: {
      activated: false,
      type: 'action',
      icon: 'credit-card',
      variant: 'primary',
      text: 'mark_as_paid',
      show: true,
      event: 'mark-invoices-as-paid',
      selectElements: true,
      tag: 'left',
      permissions: ['show'],
    },
    bulkDownloadSyncServiceFile: {
      activated: false,
      type: 'action',
      icon: 'cloud-download-alt',
      variant: 'primary',
      text: 'bulk_download_sync_service_file',
      show: false,
      event: 'bulk-download-sync-service-file',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_download'],
    },
    bulkGeneratePDF: {
      activated: false,
      type: 'action',
      icon: 'file-pdf',
      variant: 'primary',
      text: 'bulk_generate_pdf',
      show: false,
      event: 'bulk-generate-pdf',
      selectElements: true,
      tag: 'left',
      permissions: ['bulk_download'],
    },
  };

  extendUpdatePageActions() {
    if (this.config) {
      for (const activatedPageAction of this.config.data.activatedPageActions) {
        if (this.customPageActions[activatedPageAction]) {
          this.customPageActions[activatedPageAction].activated = true;
        }
      }
    }
    this.customPageActions.validateInvoices.show = this.validateInvoicePageAction;
    this.customPageActions.markInvoicesAsPaid.show = this.markInvoicesAsPaidPageAction;

    this.customPageActions.bulkSendMessageUsingTemplate.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME) &&
      this.sendInvoiceAction;

    this.customPageActions.bulkDownloadSyncServiceFile.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated('accounting_integrations');

    this.customPageActions.bulkGeneratePDF.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;

    this.customPageActions.invoicesToSyncItems.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated('accounting_integrations') &&
      this.syncInvoicePageAction;

    this.customPageActions.syncPayments.show =
      this.$refs.provider &&
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed &&
      this.$modulesService.hasModuleActivated('accounting_integrations') &&
      (this.syncServiceName === 'exact' || this.syncServiceName === 'odoo') && // NOTE: For now, only Exact and Odoo can sync payments
      this.syncPaymentPageAction;

    this.customPageActions.ticketsToDirectDebitFile.show = this.bulkAddToDirectDebitFilePageAction;

    this.defaultPageActions.bulkSoftDelete.show =
      this.bulkMoveToTrashPageAction && this.$refs.provider.queryConfig.params.status !== 'trash';
    this.defaultPageActions.create.show =
      this.$refs.provider.queryConfig.params.status !== 'trash' &&
      !this.$refs.provider.queryConfig.params.onlyTrashed;

    // Check Permissions
    for (const activatedPageAction of this.config.data.activatedPageActions) {
      if (
        this.customPageActions[activatedPageAction] &&
        this.customPageActions[activatedPageAction]['permissions']
      ) {
        this.checkPermission(activatedPageAction);
      }
    }
  }

  get pageActions() {
    return {
      ...this.customPageActions,
      ...this.defaultPageActions,
    };
  }

  customOnPageAction($event: string) {
    switch ($event) {
      case 'bulk-send-message-using-template':
        this.onBulkSendMessageUsingTemplate(this.selection);
        break;
      case 'invoices-to-sync-items':
        this.onInvoicesToSyncItems();
        break;
      case 'sync-payments':
        this.onSyncPayments();
        break;
      case 'tickets-to-invoice':
        this.onTicketsToInvoice();
        break;
      case 'validate-invoices':
        this.bulkInvoiceValidation = true;
        this.onShowValidateInvoiceModal(null);
        break;
      case 'mark-invoices-as-paid':
        this.onShowMarkInvoicesAsPaidModal();
        break;
      case 'bulk-download-sync-service-file':
        this.onBulkDownloadSyncServiceFile();
        break;
      case 'bulk-generate-pdf':
        this.onBulkGeneratePDF();
        break;
      case 'tickets-to-direct-debit-file':
        this.onTicketsToDirectDebitFile();
        break;
    }
  }

  async onConfirmBulkGeneratePDF() {
    const url = this.$bpcApiRouteHelper.getEntityPath('invoices');
    const params = this.getDownloadInvoicesQueryParams();
    this.$bpcApi.postDownload(`${url}/generate-pdf/`, '', { ...params }).subscribe(res => {
      console.log(res);
    });
  }

  getDownloadInvoicesQueryParams() {
    return {
      ids: this.selection,
      ...this.$refs.provider.queryConfig.params,
    };
  }

  onBulkGeneratePDF() {
    // TODO: aqui
    this.showBulkPDFModal = true;
  }
  onCancelBulkPDF() {
    this.showBulkPDFModal = false;
  }
  onCloseBulkPDF() {
    this.showBulkPDFModal = false;
  }

  getDocumentNameForBulkPDF(): string {
    if (this.invoicesSelectedToBulkPrint.length < 1) {
      return this.$t('global.invoice.label') as string;
    }

    const first = this.invoicesSelectedToBulkPrint[0];
    if (this.invoicesSelectedToBulkPrint.length === 1) {
      const baseName = this.$t('global.invoice.label');
      return `${baseName}-${first?.document_number || ''}.pdf`;
    }

    if (this.invoicesSelectedToBulkPrint.length > 1) {
      const baseName = this.$t('global.models.invoice.heading');
      const last = this.invoicesSelectedToBulkPrint[this.invoicesSelectedToBulkPrint.length - 1];

      return `${baseName}-${first?.document_number || ''}-${last?.document_number || ''}.pdf`;
    }

    return this.$t('global.models.invoice.heading') as string;
  }

  onGeneratedBulkPDF(e) {
    setTimeout(() => {
      this.bulkPrinting = false;
      this.downloadBulkPDF = false;
      this.invoicesSelectedToBulkPrint = [];
      this.$refs.bulkPdfConfirmationModal.onCloseModal();
    }, 300);
  }

  onBulkDownloadSyncServiceFile() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoice-sync-items');
    const invoiceSyncItems = this.getSelectedInvoiceSyncItemIds();
    if (invoiceSyncItems.length) {
      const fileName = `invoice-sync-${Date.now()}.zip`;
      this.$bpcApi
        .postDownload(`${basePath}/bulk-download`, fileName, {
          invoice_sync_item_ids: invoiceSyncItems,
        })
        .subscribe(
          res => {
            console.log(res);
          },
          error => {
            this.$bpcMessage.showErrorMessage({
              text: 'global.invoice_sync_item.bulk_download.error',
            });
          },
        );
    } else {
      // TODO display modal error
    }
  }

  getSelectedInvoiceSyncItemIds() {
    const items: Invoice[] = this.$refs?.provider?.items || [];
    return items
      .filter(item => item.checked)
      .filter(item => !!item.invoice_sync_item)
      .map(item => item.invoice_sync_item.id);
  }

  onTicketsToInvoice() {
    this.$refs.ticketsToInvoiceConfirmationModal.onOpenModal(null);
  }

  onTicketsToDirectDebitFile() {
    this.showTicketAddToDirectDebitFileModal = true;
  }

  async onMakeStripePayment() {
    await this.$refs.stripePaymentModal.makePayment();
  }

  async onMakeBancontactPayment() {
    await this.$refs.bancontactPaymentModal.makePayment();
  }

  onSendBulkInvoices() {
    this.$refs.bulkSendInvoicesConfirmationModal.onOpenModal(null);
  }

  onConfirmTicketsToInvoice() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoices');
    this.$bpcApi
      .post(basePath + '/from-tickets', {
        tickets: this.selection,
        ...this.ticketsToInvoiceFormModel,
      })
      .subscribe(
        res => {
          this.$refs.provider.getEntities();
          this.$refs.ticketsToInvoiceConfirmationModal.onCloseModal();
        },
        error => {
          const errorMessage = error?.response?.data?.message || 'global.tickets_to_invoice.error';

          this.$bpcMessage.showErrorMessage({
            text: `${this.$t(errorMessage)}`,
          });
        },
      );
  }

  onConfirmSendBulkInvoices() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoice');
    this.$bpcApi
      .post(basePath + '/send-bulk', {
        invoices: this.selection,
      })
      .subscribe(
        res => {
          this.$refs.provider.getEntities();
          this.$refs.bulkSendInvoicesConfirmationModal.onCloseModal();
        },
        error => {
          this.$bpcMessage.showErrorMessage({
            text: 'global.send_invoice.bulk.error',
          });
        },
      );
  }

  public customRowActionsBefore = {
    validate: {
      activated: true,
      type: 'action',
      icon: 'check-circle',
      show: false,
      event: 'validate-invoice',
      text: 'validate',
      permissions: ['show'], // JJFC TODO: clear the needed permission
    },
    pay: {
      activated: false,
      type: 'action',
      icon: 'credit-card',
      show: false,
      event: 'pay',
      text: 'pay',
      permissions: ['pay'],
    },
    copyPaymentLink: {
      activated: false,
      type: 'action',
      icon: 'link',
      show: false,
      event: 'copy-payment-link',
      text: 'copy_payment_link',
      permissions: ['show'],
    },
    publicPay: {
      activated: false,
      type: 'action',
      icon: 'credit-card',
      show: false,
      event: 'public-pay',
      text: 'public_pay',
      permissions: ['show'],
    },
    sendToPosCheckout: {
      activated: false,
      type: 'action',
      icon: 'calculator',
      show: false,
      event: 'send-to-pos-checkout',
      text: 'send_to_pos_checkout',
      permissions: ['update'],
    },
    sendToPosCheckoutV2: {
      activated: false,
      type: 'action',
      icon: 'calculator',
      show: false,
      event: 'send-to-pos-checkout-v2',
      text: 'send_to_pos_checkout_v2',
      permissions: ['update'],
    },
    downloadSyncServiceFile: {
      activated: false,
      type: 'action',
      icon: 'cloud-download-alt',
      show: false,
      event: 'download-sync-service-file',
      text: 'download_sync_service_file',
      permissions: ['download'],
    },
    printTicket: {
      activated: false,
      type: 'action',
      icon: 'print',
      show: false,
      event: 'print-ticket',
      text: 'print_ticket',
      permissions: ['download'],
    },
    printPreviewTicket: {
      activated: false,
      type: 'action',
      icon: 'eye',
      show: false,
      event: 'print-preview-ticket',
      text: 'print_preview_ticket',
      permissions: ['download'],
    },
  };

  customRowActions = {
    sendMessageUsingTemplate: {
      activated: true,
      type: 'action',
      icon: 'envelope',
      show: true,
      event: 'send-message-using-template',
      text: 'send_message_using_template',
      permissions: ['send'],
    },
    download_pdf: {
      activated: true,
      type: 'action',
      icon: 'download',
      show: true,
      event: 'download-pdf',
      text: 'download',
      permissions: ['show'],
    },
  };

  printing: boolean = false;
  bulkPrinting: boolean = false;
  downloadBulkPDF: boolean = false;
  documentNameForBulkPDF: string = 'download.pdf';
  invoiceSelectedToPrint: Invoice = null;
  invoicesSelectedToBulkPrint: Invoice[] = [];

  get rowActions() {
    return {
      ...this.customRowActionsBefore,
      ...this.defaultRowActions,
      ...this.customRowActions,
    };
  }

  get showActionButton(): boolean {
    if (this.canBeValidated || this.canBeReDrafted) {
      return true;
    }
    return false;
  }

  get canBeValidated(): boolean {
    return !!this.entity?.can_be_validated;
  }

  get canBeReDrafted(): boolean {
    return (
      ['invoice', 'credit_note'].includes(this.entity?.invoice_type) &&
      this.entity?.status === 'to_pay'
    );
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Invoice;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  onNew() {
    this.$bpcStorage.clear('orders');
    // this.showDrawerLarge = false;
    this.entity = null;
    this.showForm = true;
    this.showDrawerSection = true;
    this.disabledForm = false;
  }

  onEdit(e, disabled = false) {
    this.$bpcStorage.clear('orders');
    // this.showDrawerLarge = true;
    this.entity = e.item;
    this.showForm = true;
    this.showDrawerSection = true;
    setTimeout(() => {
      this.disabledForm = disabled;
    });
  }
  onShow(e) {
    this.$bvModal.show('modal-invoice-details');
    this.entity = e.item;
    this.invoiceDetailsModalTitle = this.getInvoiceDetailsModalTitle();
    this.invoiceCode = this.getInvoiceCode(this.entity);
  }

  getInvoiceDetailsModalTitle() {
    const label = this.$t(`global.invoice_type.${this.entity['invoice_type']}`) as string;
    const status = this.$t('global.status.' + this.entity['status']) as string;
    const codeConfig = this.getFieldDisplayConfig('code');
    const onNullValue = codeConfig ? (this.$t(codeConfig['onNullValue']) as string) : null;
    const code = this.entity.document_number || this.entity.code || null;

    if (code) {
      return `${label}` + ' # ' + `${code}` + ' [' + `${status}` + ']';
    }

    return onNullValue ? `${label}` + ' ' + `${onNullValue}` : '';
  }

  getInvoiceCode(invoice: Invoice) {
    const code = invoice.code || null;
    const codeConfig = this.getFieldDisplayConfig('code');
    const onNullValue = codeConfig ? (this.$t(codeConfig['onNullValue']) as string) : null;

    if (code) {
      return code;
    }

    return onNullValue ? onNullValue : '';
  }

  onGeneratedInvoice() {
    setTimeout(() => {
      this.printing = false;
      this.invoiceSelectedToPrint = null;
    }, 300);
  }

  async onDownload(invoice: Invoice) {
    const url = this.$bpcApiRouteHelper.getEntityPath('invoices');
    this.$bpcApi
      .postDownload(`${url}/generate-pdf/`, '', {
        invoice_ids: [invoice.id],
        tenant_id: this.tenantId,
      })
      .subscribe(res => {
        console.log(res);
      });
  }

  onPay(e) {
    console.log('clickOnPay', e);
    this.entity = e.item;
    // TO-DO: implement this with the event "model-loaded" (implemented in BPS-1579)
    setTimeout(() => {
      this.$refs.paymentStdForm.formModel.paid_amount = this.entity.balance;
    }, 3000);
    this.showDrawerPaymentSection = true;
  }

  onPublicPay(e) {
    // console.log('clickOnPublicPay', e);
    this.$router.push({
      name: 'profile-payment-invoice',
      params: { token: e.item.invoice_token },
    });
  }

  onCopyPaymentLink(e) {
    // console.log('clickOnCopyPaymentLink', e);
    // const link =
    // window.location.origin +
    // '/' +
    // this.$clientRouter.getTenantAlias() +
    // '/payment-invoice/' +
    // e.item.invoice_token;
    const link = this.$clientRouter.getFullClientUrl(`payment-invoice/${e.item.invoice_token}`);
    copy(link);
    this.$bpcMessage.showSuccessMessage({ text: this.copiedText });
  }

  onSendSingleInvoice(e) {
    this.$refs.sendSingleInvoiceConfirmationModal.onOpenModal(e.item.id);
  }

  onConfirmSendSingleInvoice(e) {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoice');
    this.$bpcApi
      .post(basePath + '/send-single', {
        invoiceId: e['entityIdOrIds'],
      })
      .subscribe(
        res => {
          this.$refs.provider.getEntities();
          this.$refs.sendSingleInvoiceConfirmationModal.onCloseModal();
        },
        error => {
          this.$bpcMessage.showErrorMessage({
            text: 'global.send_invoice.single.error',
          });
        },
      );
  }
  onSendToPosCheckout(e) {
    this.$refs.sentToPosCheckoutConfirmationModal.onOpenModal(e.item.id);
  }
  onSendToPosCheckoutV2(e) {
    this.$refs.sentToPosCheckoutConfirmationModalV2.onOpenModal(e.item.id);
  }
  onSendToPosCheckoutV2FromEntity(entity) {
    this.$refs.sentToPosCheckoutConfirmationModalV2.onOpenModal(entity.id);
  }
  onConfirmSendToPosCheckout(e) {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoice');
    this.$bpcApi
      .post(basePath + '/send-to-pos-checkout', {
        invoice_id: e['entityIdOrIds'],
      })
      .subscribe(
        res => {
          this.$refs.provider.getEntities();
          this.$refs.sentToPosCheckoutConfirmationModal.onCloseModal();
          this.$store.commit('pos/showDrawer');
          this.$store.dispatch('pos/getOpenTickets');
          this.$store.commit('pos/storeCurrentTicketId', e['entityIdOrIds']);
        },
        error => {
          this.$bpcMessage.showErrorMessage({
            text: 'global.generic.error_form_action',
          });
        },
      );
  }

  onConfirmSendToPosCheckoutV2(e) {
    console.log(e['entityIdOrIds']);
    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoice');
    this.$bpcApi
      .post(basePath + '/send-to-pos-checkout', {
        invoice_id: e['entityIdOrIds'],
        pos_session_id: this.openPosSessionId,
      })
      .subscribe(
        res => {
          this.$refs.provider.getEntities();
          this.$refs.sentToPosCheckoutConfirmationModalV2.onCloseModal();
          this.$router.push({
            name: 'pos-page',
            params: {
              initialPosSessionId: `${this.openPosSession.id}`,
              initialTicketId: `${e['entityIdOrIds']}`,
            },
          });
        },
        error => {
          this.$bpcMessage.showErrorMessage({
            text: 'global.generic.error_form_action',
          });
        },
      );
  }

  getModalPaymentTitle() {
    return this.$t('global.modals.create') + ' ' + this.$t('global.models.payment.name');
  }

  onFormPaymentClose() {
    this.showForm = false;
    this.showDrawerPaymentSection = false;
    this.i++;
    this.isSavingForm = false;
  }

  async onFormPaymentSave() {
    console.log('Saving');
    this.nextAction = '';
    const paymentMethodType = getProp(this.$refs.paymentStdForm.formModel, 'payment_method_type');
    this.payAmount = Number(this.$refs.paymentStdForm.formModel.paid_amount);
    if (paymentMethodType === 'stripe_card') {
      this.showStripePaymentModal = true;
    } else if (paymentMethodType === 'stripe_bancontact') {
      this.showBancontactPaymentModal = true;
    } else if (paymentMethodType === 'wipay_terminal') {
      await this.manageWipayTerminalPayment();
    } else {
      this.$refs.paymentStdForm.formModel.invoice_id = this.entity.id;
      this.$refs.paymentStdForm.saveEntity();
    }
  }

  async manageWipayTerminalPayment() {
    this.$refs.paymentStdForm.formModel.invoice_id = this.entity.id;
    const res = await this.$refs.paymentStdForm.saveEntity();
    this.paymentEntity = res.data;
    await this.getWipayTerminalsIfNeeded();

    if (!this.terminals.length) {
      this.$bpcMessage.showErrorMessage({
        text: 'payment_terminals.terminals.there_is_no_terminal_configured',
      });
    } else {
      this.showWipayTerminalPaymentModal = true;
    }
  }

  async getWipayTerminalsIfNeeded() {
    if (!(this.terminals && this.terminals.length)) {
      const terminalRoute = this.$bpcApiRouteHelper.getEntityPath('terminals');
      const terminalRes = await this.$bpcApi.get(terminalRoute).toPromise();
      this.terminals = terminalRes.data;
    }
  }

  onSuccessStripePayment($event) {
    this.stripeKey++;
    this.showStripePaymentModal = false;
    setProp(this.$refs.paymentStdForm.formModel, 'payment_method_result', $event);
    setProp(this.$refs.paymentStdForm.formModel, 'invoice_id', this.entity.id);
    this.$refs.paymentStdForm.saveEntity();
  }

  onFormPaymentSaved($event: any = null) {
    if (this.nextAction === 'new') {
      this.setEntityAttributesAfterSave();
      this.$refs.provider.getEntities();
    } else {
      this.onFormClose();
      this.$refs.provider.getEntities();
    }
    this.showDrawerPaymentSection = false;
  }

  onShowValidateInvoiceModal(e: any = null) {
    this.searchAndOrder = this.$refs.provider?.searchAndOrder;
    this.entity = e;
    this.showInvoiceValidationModal = true;
  }
  onCloseValidateinvoiceModal() {
    this.showInvoiceValidationModal = false;
  }

  onShowRedraftInvoiceModal() {
    this.showInvoiceRedraftModal = true;
  }

  onCloseRedraftModal() {
    this.showInvoiceRedraftModal = false;
  }

  onRedrafted() {
    this.showInvoiceRedraftModal = false;
    this.$refs.provider.getEntities();
    this.showDrawerSection = false;
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  onShowMarkInvoicesAsPaidModal(e: any = null) {
    this.searchAndOrder = this.$refs.provider?.searchAndOrder;
    this.entity = e;
    this.showInvoiceMarkAsPaidModal = true;
  }

  onCloseMarkInvoicesAsPaidModal() {
    this.showInvoiceMarkAsPaidModal = false;
  }

  onCloseTicketToDirectDebitFileModal() {
    this.showTicketAddToDirectDebitFileModal = false;
    this.$refs.provider.getEntities();
  }

  onCloseStripePaymentModal() {
    this.stripeKey++;
    this.showStripePaymentModal = false;
  }

  onCloseWipayTerminalPaymentModal() {
    this.wipayTerminalKey++;
    this.showWipayTerminalPaymentModal = false;
  }

  onSuccessWipayTerminalPayment($event) {
    this.wipayTerminalKey++;
    this.showWipayTerminalPaymentModal = false;
    // setProp(this.$refs.paymentStdForm.formModel, 'payment_method_result', $event);
    // setProp(this.$refs.paymentStdForm.formModel, 'invoice_id', this.entity.id);
    // this.$refs.paymentStdForm.saveEntity();
  }

  onCloseStripeCancelModal() {
    this.showStripeCancelModal = false;
    this.stripePaymentIntentId = null;
    setProp(this.$refs.paymentStdForm.formModel, 'payment_method_result', null);
  }

  onCloseBancontactPaymentModal() {
    this.showBancontactPaymentModal = false;
  }

  onPaymentErrorSaving() {
    const paymentMethod = getProp(this.$refs.paymentStdForm.formModel, 'payment_method_type');
    if (paymentMethod === 'stripe_card') {
      this.stripePaymentIntentId = getProp(
        this.$refs.paymentStdForm.formModel.payment_method_result,
        'id',
      );
      this.showStripeCancelModal = true;
    }
  }

  onChangeAccountingJournal(entity: any) {
    this.$refs.stdForm.formModel.center_data = entity?.header_text ? entity.header_text : null;
    this.$refs.stdForm.formModel.footer_text = entity?.footer_text ? entity.footer_text : null;
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.validate.show =
      this.tableIsNotFilteredByTrashedElements() && entity?.can_be_validated;

    if (entity.status === 'to_pay') {
      entity.actions.pay.show = this.tableIsNotFilteredByTrashedElements();
      if (entity.invoice_token) {
        entity.actions.copyPaymentLink.show = this.tableIsNotFilteredByTrashedElements();
        if (
          this.tableIsNotFilteredByTrashedElements() &&
          (entity.invoice_type === 'ticket' ||
            (entity.invoice_type === 'invoice' && this.$authService.allowedToPayOnlineInvoices()))
        ) {
          entity.actions.publicPay.show = true;
        }
      }
    }
    if (
      this.tableIsNotFilteredByTrashedElements() &&
      !entity.in_pos_checkout &&
      entity.invoice_type === 'ticket' &&
      entity.pos_session_id &&
      entity.pos_session_id == this.openPosSessionId &&
      !appConfig.modules.activatePosV2
    ) {
      entity.actions.sendToPosCheckout.show = true;
    }
    if (
      this.tableIsNotFilteredByTrashedElements() &&
      this.$authorizationService.hasPermissionForAction('pos_sessions', 'pos_checkout', true) &&
      entity.invoice_type === 'ticket' &&
      (entity.status === 'to_pay' || entity.status === 'refused') &&
      this.openPosSessionId &&
      this.$store.getters['centerSettings/usePosV2'] &&
      appConfig.modules.activatePosV2
    ) {
      entity.actions.sendToPosCheckoutV2.show = true;
    }
    if (
      this.tableIsFilteredByTrashedElements() ||
      entity.status === 'to_pay' ||
      entity.status === 'paid'
    ) {
      entity.actions.softDelete.show = false;
    }
    entity.actions.sendMessageUsingTemplate.show =
      this.tableIsNotFilteredByTrashedElements() &&
      this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);
    if (
      this.tableIsNotFilteredByTrashedElements() &&
      this.$modulesService.hasModuleActivated('accounting_integrations') &&
      entity?.invoice_sync_item?.status === 'synced' &&
      entity?.invoice_sync_item?.sync_service_type === 'file' &&
      entity?.sync_service_file?.url
    ) {
      entity.actions.downloadSyncServiceFile.show = true;
    }

    if (this.tableIsNotFilteredByTrashedElements() && entity?.invoice_type === 'ticket') {
      entity.actions.printTicket.show = true;
    }
    if (this.tableIsNotFilteredByTrashedElements() && entity?.invoice_type === 'ticket') {
      entity.actions.printPreviewTicket.show = true;
    }

    return null;
  }

  onRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'delete':
        this.onDelete($event.item);
        break;
      case 'soft-delete':
        this.onSoftDelete($event.item);
        break;
      case 'recover':
        this.onRecover($event.item);
        break;
      case 'edit':
        this.onEdit($event.item);
        break;
      case 'show':
        this.onShow($event.item);
        break;
      case 'select':
        this.onSelect($event.item);
        break;
      case 'pay':
        this.onPay($event.item);
        break;
      case 'download-pdf':
        this.onDownload($event.item?.item);
        break;
      case 'send-message-using-template':
        this.onSendMessageUsingTemplate($event.item?.item);
        break;
      case 'copy-payment-link':
        this.onCopyPaymentLink($event.item);
        break;
      case 'public-pay':
        this.onPublicPay($event.item);
        break;
      case 'send-to-pos-checkout':
        this.onSendToPosCheckout($event.item);
        break;
      case 'send-to-pos-checkout-v2':
        this.onSendToPosCheckoutV2($event.item);
        break;
      case 'validate-invoice':
        this.bulkInvoiceValidation = false;
        this.onShowValidateInvoiceModal($event.item.item);
        break;
      case 'download-sync-service-file':
        this.downloadSyncServiceFile($event.item);
        break;
      case 'print-ticket':
        this.onPrintTicket($event.item.item);
        break;
      case 'print-preview-ticket':
        this.onPrintPreviewTicket($event.item.item);
        break;
    }
    console.log('Row action event >>> ' + $event);
  }

  async onPrintTicket(ticket: Invoice) {
    if (!this.disablePrintingTicket) {
      this.printPreviewTicket = false;
      await this.openTicketInNewWindow(ticket);
    } else {
      this.$bpcMessage.showWarningMessage({
        text: 'global.print_ticket_already_printing_warning',
      });
    }
  }

  async onPrintPreviewTicket(ticket: Invoice) {
    if (!this.disablePrintingTicket) {
      this.printPreviewTicket = true;
      await this.openTicketInNewWindow(ticket);
    } else {
      this.$bpcMessage.showWarningMessage({
        text: 'global.print_ticket_already_printing_warning',
      });
    }
  }

  async openTicketInNewWindow(ticket) {
    this.printingTicket = true;
    this.disablePrintingTicket = true;
    this.ticketToPrint = ticket;
    this.paymentsInTicketToPrint = ticket.payments;
    this.orderItemsInTicketToPrint = await TicketHelper.getProcessedOrderItemsByTicketId(ticket.id);
    await this.$nextTick();
    this.$refs.htmlToPrinter.printContent();
  }

  onRenderedPrintingTicket() {
    this.disablePrintingTicket = false;
  }

  onStopPrintingTicket() {
    this.printingTicket = false;
    this.printPreviewTicket = false;
    this.ticketToPrint = null;
    this.orderItemsInTicketToPrint = [];
    this.paymentsInTicketToPrint = [];
  }

  get posUserName() {
    const posSession = this.$store.getters['pos/openPosSession'];
    return posSession?.profile?.user?.name;
  }

  downloadSyncServiceFile(item) {
    const downloadUrl = item?.item?.sync_service_file?.url;
    window.location.href = downloadUrl;
  }

  calculateTotalAmount() {
    const orders =
      this.$refs.stdForm && this.$refs.stdForm.formModel ? this.$refs.stdForm.formModel.orders : [];
    let totalAmount: number = 0;
    let totalTax: number = 0;
    orders.forEach(item => {
      totalAmount += item.total_price;
      if (item.order_items) {
        item.order_items.forEach(order_item => {
          totalTax += order_item.total_tax;
        });
      }
    });
    this.$set(this.$refs.stdForm.formModel, 'total_amount', Number(totalAmount).toFixed(2));
    this.$set(this.$refs.stdForm.formModel, 'total_tax', Number(totalTax).toFixed(2));
    this.calculateBalance();
  }

  calculateBalance() {
    const totalAmount = this.$refs.stdForm.formModel.total_amount;
    const paidAmount = this.$refs.stdForm.formModel.paid_amount;
    this.$set(this.$refs.stdForm.formModel, 'balance', (totalAmount - paidAmount).toFixed(2));
  }

  // TODO: Need to implement this logic after redirection
  async checkBancontactPayment() {
    const clientSecret = this.$route.query['payment_intent_client_secret'];

    if (clientSecret && typeof clientSecret === 'string') {
      const publicKey = this.$store.getters['centerSettings/stripePublicKey'];
      const stripe = await loadStripe(publicKey);
      stripe.retrievePaymentIntent(clientSecret).then(function(response) {
        if (response.error) {
          // Handle error here
        } else if (response.paymentIntent && response.paymentIntent.status === 'succeeded') {
          // Handle successful payment here
        }
      });
    }
  }

  // LIFECYCLE

  mounted() {
    // Check bancontact payment after redirect
    this.checkBancontactPayment();
    this.prepareTicketsToInvoiceForm();

    this.$root.$on('calculateTotalAmount', event => {
      setTimeout(() => {
        this.calculateTotalAmount();
      });
    });
    this.$root.$on('calculateTotalAmountFromSelectTableToInvoiceTable', event => {
      setTimeout(() => {
        this.calculateTotalAmount();
      });
    });
    this.$root.$on('calculateBalance', event => {
      this.calculateBalance();
    });

    // For messages with templates
    const templatesRequest = [this.getAllowedTemplatesForSendMessage()];

    Promise.all(templatesRequest).then(res => {
      this.updateRowActions();
      this.updatePageActions();
    });

    this.$root.$on('updatePaymentsFromInvoiceForm', event => {
      const newPaymentIdsStr = this.getPaymentIdsStr();
      console.log(newPaymentIdsStr + ' vs ' + this.paymentIdsStr);
      if (this.paymentIdsStr !== newPaymentIdsStr) {
        if (this.paymentIdsStr !== 'loading') {
          this.uniqIdForInvoiceForm = this.generateUUIDv4();
          this.$refs.provider.getEntities();
        }
        this.paymentIdsStr = newPaymentIdsStr;
      }
    });

    this.$root.$on('updateClearanceFromInvoiceForm', event => {
      this.paymentIdsStr = 'loading';
      this.uniqIdForInvoiceForm = this.generateUUIDv4();
      this.$refs.provider.getEntities();
    });

    this.$root.$on('calculateBalance', event => {
      this.calculateBalance();
    });

    this.$root.$on('changeAccountingJournal', event => {
      this.onChangeAccountingJournal(event);
    });
  }

  destroyed() {
    this.$root.$off('calculateTotalAmount');
    this.$root.$off('calculateTotalAmountFromSelectTableToInvoiceTable');
    this.$root.$off('calculateBalance');
    this.$root.$off('updatePaymentsFromInvoiceForm');
    this.$root.$off('updateClearanceFromInvoiceForm');
    this.$root.$off('changeAccountingJournal');
  }

  get openPosSessionId(): PosSession {
    return this.$store.getters['pos/openPosSessionId'];
  }

  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;

  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }

  onCloseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }

  // Here, put the same fields as you put in dataToShowForBulkTrashedEntity in your entity Service
  bulkMoveToTrashDataToShow = [['code'], ['contact'], ['priceCategory']];

  // Bulk restore modal (recover)

  showBulkRecoverModal = false;

  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }

  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }

  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }

  bulkRecoverDataToShow = [['code'], ['contact'], ['priceCategory']];

  invoiceValidationFinished() {
    this.$refs.provider.getEntities();
    this.uniqIdForInvoiceForm = this.generateUUIDv4();
  }

  invoiceMarkAsPaidFinished() {
    this.$refs.provider.getEntities();
  }

  @Watch('filterConfigName')
  onChangeFilterConfigName() {
    this.$refs.provider.getEntities();
  }
}
